import { Home, Monitor } from 'lucide-react';

type TuitionMode = 'physical' | 'online' | 'both';

interface TuitionModeSelectorProps {
  value: string;
  onChange: (value: TuitionMode | '') => void;
}

const TuitionModeSelector = ({ value, onChange }: TuitionModeSelectorProps) => {
  const togglePhysical = () => onChange(value === 'physical' ? '' : value === 'both' ? 'online' : 'physical');
  const toggleOnline = () => onChange(value === 'online' ? '' : value === 'both' ? 'physical' : 'online');
  const toggleBoth = () => onChange(value === 'both' ? '' : 'both');

  const buttonClass = (selected: boolean) => `flex cursor-pointer flex-col items-center space-y-3 rounded-xl px-4 py-5 font-medium transition-all focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 ${
    selected
      ? 'border-2 border-primary bg-primary-50 text-primary shadow-sm'
      : 'border border-gray-200 bg-white text-gray-600 hover:border-primary-200 hover:bg-primary-50/50'
  }`;

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
      <button type="button" onClick={togglePhysical} aria-pressed={value === 'physical' || value === 'both'} className={buttonClass(value === 'physical' || value === 'both')}>
        <Home className="h-5 w-5" />
        <span className="text-sm">Physical Tuition</span>
        {(value === 'physical' || value === 'both') && <span className="text-xs font-semibold">✓ Selected</span>}
      </button>
      <button type="button" onClick={toggleOnline} aria-pressed={value === 'online' || value === 'both'} className={buttonClass(value === 'online' || value === 'both')}>
        <Monitor className="h-5 w-5" />
        <span className="text-sm">Online Tuition</span>
        {(value === 'online' || value === 'both') && <span className="text-xs font-semibold">✓ Selected</span>}
      </button>
      <button type="button" onClick={toggleBoth} aria-pressed={value === 'both'} className={buttonClass(value === 'both')}>
        <div className="flex space-x-2"><Home className="h-5 w-5" /><Monitor className="h-5 w-5" /></div>
        <span className="text-sm">Both</span>
        {value === 'both' && <span className="text-xs font-semibold">✓ Selected</span>}
      </button>
    </div>
  );
};

export default TuitionModeSelector;
